var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIncorrect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c60f13",
    d: "M15.067 1.32c.374-.873-.056-1.394-.443-1.312-.808.17-1.895 1.512-2.647 2.26a641 641 0 0 0-4.409 4.434 608 608 0 0 1-3.93-3.408c-.544-.478-1.068-.981-1.63-1.44-.81-.66-2.021-.716-2.008.157.012.815 1.532 1.87 2.29 2.611C3.537 5.842 4.794 7.05 6.05 8.26a187 187 0 0 0-3.618 3.828c-.725.792-2.406 2.14-1.647 3.345.444.706 1.258.686 1.791.31.01-.023 4.145-4.727 5.157-5.865a191 191 0 0 0 4.51 4.163c.804.716 2.3 2.55 3.391 1.626 1.365-1.153-1.472-3.295-2.105-3.83q-.03-.023-.054-.044c-1.417-1.198-2.814-2.417-4.22-3.628a645 645 0 0 1 4.07-4.567c.236-.262 1.385-1.442 1.743-2.277"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncorrect);
export default __webpack_public_path__ + "static/media/icon-incorrect.2152762e627fbb382a2e5702a0be471e.svg";
export { ForwardRef as ReactComponent };